








































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconHeart',
  props: {
    width: {
      type: String,
      default: '22',
    },
    height: {
      type: String,
      default: '20',
    },
  },
});
